import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import AMZMemberDay from '@elem/compCommon/PillarPageActivities/AMZMemberDay';
import A from './components/A';
import css from './index.module.scss';
import EfScrollAni from '@/efscrollani';

const IndexDynamic = dynamic(() => import('./indexdynamic'), { ssr: true });

export default function BatteryBackupForHome() {
    const { locale } = useRouter();
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }
    return (
        <div className={`power-backup ${css['power-backup']}`}>
            <A />
            {['us', 'ca'].includes(locale as string) && <AMZMemberDay />}
            <IndexDynamic />
            <style jsx global>
                {`
                    .ecoflow-header {
                        max-width: 100%;
                    }
                    .footer {
                        max-width: 100%;
                        overflow: hidden;
                    }
                `}
            </style>
        </div>
    );
}
